<template>
  <div class="mt-2">
    <input type="checkbox" :id="filterType" @change="changeFunc" v-model="checked">
    <label :for="filterType">{{ $t(label) }}</label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'filtercheckbox',
  props: {
    filterType: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    defaultValue: {
      type: Boolean,
      default: null
    }
  },
  data: function () {
    return {
      checked: null
    }
  },
  computed: {
    ...mapGetters([
      'routeData'
    ])
  },
  mounted: function () {
    var currentValue = this.routeData[this.$route.name]['filters'][this.filterType]

    if (currentValue !== null && currentValue !== undefined && currentValue !== '') {
      this.checked = currentValue
    } else if (this.defaultValue !== null) {
      this.checked = this.defaultValue
      this.setFilter(this.defaultValue)
    } else {
      this.checked = false
    }
  },
  methods: {
    changeFunc: function () {
      if (this.checked) {
        this.setFilter(this.checked)
      } else {
        this.resetFilter()
      }
    },
    setFilter: function (newVal) {
      this.$store.commit('setRouteFilterData', {
        routeName: this.$route.name,
        filterType: this.filterType,
        value: newVal
      })
    },
    resetFilter: function () {
      this.$store.commit('setRouteFilterData', {
        routeName: this.$route.name,
        filterType: this.filterType,
        value: ''
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// FilterCheckbox.vue?5e0049ea